import React from "react";
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import '../../sass/components/flexibleModules/_components.imageGallery.scss';

const ImageGalleryComponent = ({ data }) => {
    return (
        <div className="cp-genericImageGallery" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-genericImageGallery__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth/16+"rem") : ""}`, margin: "0 auto" }}>
                <h2 dangerouslySetInnerHTML={{ __html: data.genericImageGalleryHeader }} />
                {data.genericImageGalleryLink &&
                    <a href={data.genericImageGalleryLink.url} target={data.genericImageGalleryLink.target}>
                        {data.genericImageGalleryLink.title &&
                            <span>{data.genericImageGalleryLink.title}</span>
                        }
                        <StaticImage src='../../images/arrow-pro-right.svg' alt="" />
                    </a>
                }
                <div className="cp-genericImageGallery__gallerySection l--flex">
                    {data.genericImageGalleryImages &&
                        <>
                            {data.genericImageGalleryImages.map((imageSection, index) => (
                                <div key={index} className={`l-gallerySection l-gallerySection${index}`}>
                                    {imageSection &&
                                        <GatsbyImage image={getImage(imageSection.gatsbyImage)} alt={imageSection.altText} />
                                    }
                                </div>
                            ))}
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default ImageGalleryComponent;